import Model from './Model'

export default class Relationship {
  static classes: {[key: string]: typeof Model} = {}

  static register(key: string, klass: typeof Model) {
    this.classes[key] = klass
  }

  static process(key: string, values: any) {
    const klass = this.classes[key]
    if (!klass) throw new Error(`Unable to find Relationship registry for "${key}"`)

    return klass.newArray(values)
  }

  static processAll(data: Object) {
    Object.keys(data).forEach(key => {
      this.process(key, data[key])
    })
  }
}
